<template>
  <div>
    <textarea
      :id="id"
      :value="inputValue"
      :rows="rows"
      :cols="cols"
      :placeholder="placeholder"
      :disabled="disabled"
      :readonly="readonly"
      :class="{ errorInput: errors.length }"
      class="form-control"
      v-on="handlers"
      @keydown.enter.exact.stop
      @keyup.enter.exact.stop />
    <div class="after-input">
      <slot
        name="after-input"
        :errors="errors">
        <span
          :id="errorId"
          class="validator-error">
          {{ errorMessage }}
        </span>
      </slot>
    </div>
  </div>
</template>

<script setup>
/* Imports */

import { toRefs, watch } from 'vue';
import { defineValidationField } from '@/utils/validation/validationModes.js';
const emits = defineEmits(['update:modelValue']);

const properties = defineProps({
  id: {
    type: String,
    required: true,
  },
  modelValue: {
    type: [String, Number],
    default: '',
  },
  rules: {
    type: [String, Object],
    default: '',
  },
  trim: {
    type: Boolean,
    default: false,
  },
  placeholder: {
    type: String,
    default: '',
  },
  name: {
    type: String,
    required: true,
  },
  mode: {
    type: String,
    default: 'validDirty',
    validator: (value) => ['aggressive', 'passive', 'lazy', 'eager', 'validDirty'].includes(value),
  },
  errorId: {
    type: String,
    default: null,
  },
  rows: {
    type: Number,
    default: 3,
  },
  cols: {
    type: Number,
    default: 20,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  readonly: {
    type: Boolean,
    default: false,
  },
});

const props = toRefs(properties);

const { handlers, inputValue, errors, errorMessage, handleChange } = defineValidationField(props);

watch(props.modelValue, (val) => {
  if (val !== inputValue.value) {
    handleChange(val);
  }
});

watch(inputValue, (val) => {
  emits('update:modelValue', props.trim.value ? val.trim() : val);
});
</script>
